var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6325 6.433L9.81075 0.25475C9.98475 0.0849167 10.1837 0 10.4075 0C10.6313 0 10.8302 0.0849167 11.0042 0.25475C11.1781 0.42875 11.265 0.628666 11.265 0.8545C11.265 1.08033 11.1781 1.28025 11.0042 1.45425L4.23525 8.22925C4.06525 8.39925 3.86433 8.48425 3.6325 8.48425C3.40067 8.48425 3.19975 8.39925 3.02975 8.22925L0.25475 5.45425C0.0849171 5.28025 0 5.08033 0 4.8545C0 4.62867 0.0869169 4.42875 0.26075 4.25475C0.43475 4.08492 0.634667 4 0.8605 4C1.08633 4 1.28625 4.08492 1.46025 4.25475L3.6325 6.433Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/rightIcon.48ca61167a644b29aeeeb34180d32297.svg";
export { ForwardRef as ReactComponent };